import { cardCss } from '../../styles';
import React from 'react';
import { CheckIcon } from '../../../../../../images/components/CheckIcon';
import { Badge, Green110, Loader, Red100 } from '@traceair/tds';
import { CalculatedUploadState } from '../useCalculatedUploadState';
import { BadgeData } from './determineBadges';
import { classes, stylesheet } from 'typestyle';
import { UploadValidationStatus } from '../../../../../../consts/uploadValidationStatus';

const css = stylesheet({
  loader: {
    marginRight: 1,
  },
  loaderOnMobile: {
    $nest: {
      '&&': {
        width: 12,
        height: 12,
      },
      svg: {
        width: '100%',
        height: '100%',
      },
    },
  },
});

const isInvalidOrOverdue = (badge: BadgeData) =>
  badge.validationStatus === UploadValidationStatus.HasErrors || badge.isOverdue;

const getBadgeIcon = (badge: BadgeData, isSmall = false) => {
  switch (badge.uploadState) {
    case CalculatedUploadState.Loading:
      return (
        <Loader
          size="xs"
          color={isInvalidOrOverdue(badge) ? Red100 : undefined}
          className={classes(css.loader, isSmall && css.loaderOnMobile)}
        />
      );
    case CalculatedUploadState.Completed:
      return <CheckIcon color={isInvalidOrOverdue(badge) ? Red100 : Green110} />;
    default:
      return undefined;
  }
};

const getBadgeType = (badge: BadgeData) => {
  if (isInvalidOrOverdue(badge)) {
    return 'negative';
  }

  switch (badge.uploadState) {
    case CalculatedUploadState.Completed:
      return 'positive';
    case CalculatedUploadState.Interrupted:
      return 'negative';
    default:
      return 'neutral-gray';
  }
};

interface Props {
  badges: BadgeData[];
}

export const MissionCardBadges = ({ badges }: Props) => {
  return (
    <div className={cardCss.badgeContainer} data-intercom-target="MissionCardBadges">
      {badges.map((badge) => (
        <React.Fragment key={badge.label}>
          <Badge
            icon={getBadgeIcon(badge, true)}
            type={getBadgeType(badge)}
            className={cardCss.badgeSmall}
            label={badge.label}
            outlined
            size="s"
          />

          <Badge
            icon={getBadgeIcon(badge)}
            type={getBadgeType(badge)}
            className={cardCss.badgeLarge}
            label={badge.label}
            outlined
            size="m"
          />
        </React.Fragment>
      ))}
    </div>
  );
};
